import * as React from 'react';
import FeedbackView from '../layouts/FeedbackRequestPageView';
import { FeedbackType } from 'src/reducers/feedbackRequest';

export interface FeedbackPageProps {
  onComponentDidMount: () => void;
  onComponentWillMount: () => void;
  feedbackData: FeedbackType[];
  dateFilter: (filterStartdate: Date, filterEnddate: Date) => void;
  fbOrderView: (orderno: string, dsorderid: string) => void;
  fbOrderRated: (orderno: string, dsorderid: string) => void;
  dateReset: (filterStartdate: Date, filterEnddate: Date) => void;
}

class FeedbackListPage extends React.Component<FeedbackPageProps> {
  render() {
    return (
      <div>
        <FeedbackView
          feedbackData={this.props.feedbackData}
          dateFilter={this.props.dateFilter}
          dateReset={this.props.dateReset}
          fbOrderView={this.props.fbOrderView}
          fbOrderRated={this.props.fbOrderRated}
        />
      </div>
    );
  }
  componentDidMount() {
    this.props.onComponentDidMount();
  }
  componentWillMount() {
    // const url: string = window.location.href;
    this.props.onComponentWillMount();
  }
}

export default FeedbackListPage;



// WEBPACK FOOTER //
// ./src/components/feedbackRequest/FeedbackListPage.tsx